import { Resource } from './resource';
import gql from 'graphql-tag';

export class CompanyResource extends Resource {
  public static async list() {
    return await this.query(
      {
        query: gql`
          query {
            companies {
              id
              name
              cards {
                id
              }
            }
          }
        `
      },
      'companies'
    );
  }
  public static async listSimple() {
    return await this.query(
      {
        query: gql`
          query {
            companies {
              name
              id
            }
          }
        `
      },
      'companies'
    );
  }

  public static async add(name: string) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($name: String!) {
            addCompany(name: $name) {
              id
              name
              cards {
                id
              }
            }
          }
        `,
        variables: { name }
      },
      'addCompany'
    );
  }

  public static async update(id: number, name: string) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!, $name: String!) {
            editCompany(id: $id, name: $name) {
              id
              name
              cards {
                id
              }
            }
          }
        `,
        variables: { id, name }
      },
      'editCompany'
    );
  }

  public static async delete(id: number) {
    return await this.mutation(
      {
        mutation: gql`
          mutation($id: Int!) {
            removeCompany(id: $id)
          }
        `,
        variables: { id }
      },
      'removeCompany'
    );
  }
}
